import React from "react";
import { ArrowRight, Repeat } from "lucide-react";

export function StageBadge({ stage }) {
  if (!stage) return null;
  const isPost = stage === "post_audit";
  return (
    <span className={`inline-flex items-center gap-1 px-1.5 py-0.5 rounded-sm text-[10px] font-bold uppercase tracking-wider ${
      isPost ? "bg-indigo-100 text-indigo-700" : "bg-sky-100 text-sky-700"
    }`}>
      {isPost ? <Repeat size={10} /> : <ArrowRight size={10} />}
      {isPost ? "Post-Audit" : "Pre-Audit"}
    </span>
  );
}
